<template>
  <div class="customerCase">
    <div class="customerCase-banner">
      <div class="customerCase-bannerBox">
        <span class="edescription">{{ bannerList.alias }}</span>
        <span class="name">{{ bannerList.name }}</span>
        <span class="description">{{ bannerList.description }}</span>
      </div>
      <img :src="bannerImg" alt="" />
    </div>
    <div class="customerCase-picBox">
      <accordion :items="items"></accordion>
    </div>
    <div class="customerCase-mian">
      <div class="customerCase-mianTop">
        <img src="../../assets/bigTy.png" alt="" />
        <span>{{ typeName }}</span>
      </div>
      <div class="customerCase-mianContent">
        <div
          class="mianContentBox"
          v-for="(item, index) in customerCaseList"
          :key="index"
          @click="caseClick(item)"
        >
          <div class="mianContentBox-top">
            <img :src="item.bg" alt="" />
            <div class="mianContentBox-topTitle"></div>
            <div class="mianContentBox-topTitleBox">
              <div class="picBox"><img :src="item.pic" alt="" /></div>
              <span>{{ item.description }}</span>
            </div>
          </div>
          <div class="mianContentBox-bottom">
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="customerCase-bottom">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import accordion from "../../components/vue-accordion/vue-accordion";
export default {
  name: "customerCase",
  components: { accordion },
  metaInfo() {
    //设置浏览器标签页标题
    return {
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  data() {
    return {
      description: "",
      bannerList: {},
      bannerImg: "",
      typeName: "移动系统案例",
      total: 0,
      pageSize: 6,
      pageNo: 0,
      pageid: "",
      items: [],
      customerCaseList: []
    };
  },
  created() {
    this.getList();
    this.getItemList();
  },
  methods: {
    getList() {
      this.$axios.get("index/common/getcase").then(res => {
        if (res.status == 200) {
          // console.log(res.data.data);
          this.description = res.data.data.description;
          this.bannerList = res.data.data["01"];
          this.bannerImg = res.data.data["01"].banner[0].pic;
          this.items = res.data.data["02"];
          this.typeName = res.data.data["03"].name;
          // console.log(this.items);
        }
      });
    },

    getItemList() {
      this.$axios
        .get("index/common/json_case", {
          params: {
            page: this.pageNo,
            limit: this.pageSize,
            pageid: this.pageid
          }
        })
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            this.total = res.data.total;
            this.customerCaseList = res.data.data;
          }
        });
    },
    getType(item) {
      this.pageid = item.id;
      this.typeName = item.name;
      this.pageNo = 0;
      this.getItemList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getItemList();
    },
    caseClick(item) {
      this.$router.push({ name: "caseDetails", query: { id: item.id } });
    }
  }
};
</script>

<style scoped>
.customerCase {
  width: 1920px;
  margin: 0 auto;
}
.customerCase-banner {
  position: relative;
  width: 1920px;
  margin: 0 auto;
}
.customerCase-banner img {
  display: block;
  width: 100%;
  height: 671px;
  margin-top: 70px;
}
.customerCase-bannerBox {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 143px;
  left: 318px;
}
.customerCase-bannerBox .edescription {
  font-size: 76px;
  font-family: DIN BlackAlternate;
  font-weight: 600;
  color: #454647;
  line-height: 76px;
  display: block;
  margin-bottom: 74px;
}
.customerCase-bannerBox .name {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 21px;
}
.customerCase-bannerBox .description {
  width: 518px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
  display: block;
  margin-bottom: 100px;
}
.customerCase-picBox {
  width: 1380px;
  margin: 0 auto;
  height: 340px;
  background: #fffdff;
  border: 1px solid #ffffff;
  position: relative;
  top: -163px;
  padding: 30px 50px 21px;
}
.customerCase-mian {
  width: 1280px;
  margin: 0 auto;
}
.customerCase-mianTop {
  text-align: center;
  position: relative;
  margin-bottom: 67px;
}
.customerCase-mianTop img {
  position: absolute;
  top: -14px;
  left: 524px;
}
.customerCase-mianTop span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.customerCase-mianContent {
  display: flex;
  flex-wrap: wrap;
  /* height: 757px; */
  /* overflow: hidden; */
  margin-bottom: 82px;
}
.customerCase-mianContent .mianContentBox {
  width: 410px;
  height: 366px;
  background: #ffffff;
  box-shadow: 0px 4px 30px 0px rgba(89, 98, 107, 0.12);
  margin-right: 25px;
  margin-bottom: 25px;
  padding: 8px;
  cursor: pointer;
}
.customerCase-mianContent .mianContentBox:nth-child(3n) {
  margin-right: 0;
}
.mianContentBox-top {
  position: relative;
}
.mianContentBox-top img {
  display: block;
  width: 100%;
}
.mianContentBox-topTitle {
  width: 394px;
  height: 36px;
  background-color: rgba(13, 13, 14, 0.6);
  opacity: 0.6;
  position: absolute;
  bottom: 0;
}
.mianContentBox-topTitleBox {
  position: absolute;
  bottom: -27px;
  display: flex;
  left: 27px;
  line-height: 60px;
}
.mianContentBox-topTitleBox .picBox {
  width: 75px;
  height: 76px;
  border-radius: 50%;
  margin-right: 20px;
  border: 1px solid #ffffff;
  overflow: hidden;
}
.mianContentBox-topTitleBox .picBox img {
  display: block;
  width: 100%;
  /* border: 1px solid #ffffff; */
  /* box-shadow: 0px 2px 10px 0px rgba(76, 76, 76, 0.1);
  border-radius: 50%; */
}
.mianContentBox-topTitleBox span {
  width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.mianContentBox-bottom {
  padding-left: 27px;
  padding-top: 56px;
}
.mianContentBox-bottom span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2a2b33;
}
.customerCase-bottom {
  text-align: center;
  margin-bottom: 190px;
}
.customerCase-bottom
  >>> .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background: linear-gradient(0deg, #dc3939, #ff4242);
}
.customerCase-bottom >>> .el-pagination.is-background .btn-next,
.customerCase-bottom >>> .el-pagination.is-background .btn-prev,
.customerCase-bottom >>> .el-pagination.is-background .el-pager li {
  width: 42px;
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
}
/* .customerCase-bottom >>> .el-pagination.is-background .el-pager li:hover {
  background: linear-gradient(0deg, #dc3939, #ff4242);
} */
</style>



// WEBPACK FOOTER //
// src/views/Case/CustomerCase.vue